import { render } from "./MobileWallet.vue?vue&type=template&id=dd5dfc02&scoped=true"
import script from "./MobileWallet.vue?vue&type=script&lang=js"
export * from "./MobileWallet.vue?vue&type=script&lang=js"

import "./MobileWallet.vue?vue&type=style&index=0&id=dd5dfc02&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd5dfc02"]])

export default __exports__